export default "__VITE_ASSET__b1a54cd4__"